import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
// import CommingSoon from "../components/CommingSoon";
import FellowshipBanner from "../components/academics/FellowshipBanner";
import {
  IBannerData,
  IBenefitsMemberFromData,
  IFellowShipTestimonialData,
} from "../exports/interfaces";
import { fetchBenefitsMemberFrom } from "../api/MemberApi";
import { dynamicFailed } from "../hooks/useToast";
import BenefitsMemberFrom from "../components/benefitsmember/BenefitsMemberFrom";
import {
  fetchFellowShipBanner,
  fetchFellowShipTestimonials,
} from "../api/OurTrainingApi";
import FellowshipTestimony from "../components/academics/FellowshipTestimony";

const FellowShip = () => {
  const { setLoading } = useLoader();
  const [fellowshipBannerData, setFellowshipBannerData] = useState<
    IBannerData[]
  >([]);
  const [fellowshipTestimonialsData, setFellowshipTestimonialsData] = useState<
    IFellowShipTestimonialData[]
  >([]);
  const [benefitsMemberData, setBenefitsMemberData] = useState<
    IBenefitsMemberFromData[]
  >([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchFellowShipBanner(),
      fetchFellowShipTestimonials(),
      fetchBenefitsMemberFrom(),
    ])
      .then(
        ([
          fellowShipBannerData,
          fellowShipTestimonialsData,
          benefitsMemberFromData,
        ]) => {
          setFellowshipBannerData(fellowShipBannerData);
          setFellowshipTestimonialsData(fellowShipTestimonialsData);
          setBenefitsMemberData(benefitsMemberFromData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      )
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [benefitsMemberData.length, setLoading]);
  return (
    <>
      <FellowshipBanner fellowshipBannerData={fellowshipBannerData} />
      <FellowshipTestimony testimonials={fellowshipTestimonialsData} />
      <BenefitsMemberFrom benefitsMemberData={benefitsMemberData} />
    </>
  );
};

export default FellowShip;
